import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import Brand from "../../menhomethree/Brand";
import First from "../menevent/First";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom title="Home" subtitle="News & Events" />
        <First />
        {/* <Brand/> */}
      </section>
    </>
  );
}

export default Main;
